import Vuex from 'vuex'
import Vue from 'vue'
import article from './modules/article'
import session from '@mcity/mcity-vue-auth/dist/store/session'
import api from '../api'

Vue.config.devtools = true
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    article
  },
  state: {
    errors: [],
    presentMode: false,
    isUserAdmin: false,
    isUserLoading: false,
    mixpanelEnabled: process.env.NODE_ENV,
    adminRole: 'MCITY',
    roleList: [],
    darkMode: false
  },
  mutations: {
    logError (state, err) {
      state.errors.push(err.response)
    },
    updatePresentationMode (state) {
      state.presentMode = !state.presentMode
    },
    setIsUserAdmin (state, payload) {
      state.isUserAdmin = payload
    },
    setIsUserLoading (state, payload) {
      state.isUserLoading = payload
    },
    setRoleList (state, roles) {
      state.roleList = roles
    },
    setDarkModeVuex (state, payload) {
      state.darkMode = payload
    }
  },
  getters: {
    getPresentMode: state => state.presentMode,
    mixpanelEnabled: state => state.mixpanelEnabled === 'production',
    getErrors: state => state.errors,
    isUserAdmin: state => state.isUserAdmin
  },
  actions: {
    fetchRoleListAction ({ commit }) {
      return api.getRoleList()
        .then(response => commit('setRoleList', response.data.roles))
        .catch(e => commit('logError', e))
    }
  }
})
